export function resetState(state, initialState) {
	Object.keys(initialState).forEach(prop => {
		state[prop] = initialState[prop];
	});
}
